import { IPerformanceReport } from './../../Models/PerformanceReport';
import { AuthenticationResult } from '@azure/msal-browser';
import {
  SavePerformanceReportAction,
  SubmitPerformanceReportAction,
  SubmitTabPerformanceReportAction,
  savePerformanceReportSuccess,
  submitPerformanceReportSuccess,
  SAVE_PERFORMANCEREPORT,
  SUBMIT_PERFORMANCEREPORT,
  SUBMIT_PERFORMANCEREPORT_TAB,
  clearLoadingReport,
  LoadCompletedPerformanceReportTabsAction,
  loadCompletedPerformanceReportTabsSuccess,
  LOAD_COMPLETED_PERFORMANCEREPORT_TABS,
  submitTabPerformanceReportSuccess,
  PrintBuyHerePayHereReportAction,
  PrintRetailReportAction,
  PRINT_BHPH_REPORT,
  PRINT_RETAIL_REPORT,
  UnlockPerformanceReportAction,
  unlockPerformanceReportSuccess,
  UNLOCK_PERFORMANCEREPORT,
  LOAD_DEALER_REPORTS,
  loadDealerReports,
  LoadDealerReportsAction,
  loadDealerReportsSuccess,
  LOAD_ALL_DEALER_REPORTS,
  LoadAllDealerReportsAction,
  loadAllDealerReportsSuccess,
  CreatePerformanceReportAction,
  createPerformanceReportSuccess,
  CREATE_PERFORMANCE_REPORT,
  loadPerformanceReportSuccess,
  LoadPerformanceReportAction,
  LOAD_PERFORMANCE_REPORT,
  ROLLUP_PERFORMANCEREPORT,
  rollupPerformanceReportSuccess,
  rollupPerformanceReportFailure,
  RollupPerformanceReportAction,
  loadPerformanceReport
} from './actions';

import { put, takeLatest, all, call } from 'redux-saga/effects';
import { authService } from '../../index';
import { httpGet, httpPost } from '../../Http/HttpClient';
import { displayError, displayMessage } from '../../Helpers/Utilities';
import { DpgReportStatuses } from '../../Helpers/Constants';
import { DealerReport } from '../../Models/DealerReport';

// Create Report
function* createPerformanceReportSaga(action: CreatePerformanceReportAction) {
  try {
    const token: string = yield authService.getToken();
    const url: string = action.payload.clientId
      ? `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/${action.payload.clientId}`
      : `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport`;

    const requestPayload = {
      month: action.payload.month, 
      year: action.payload.year, 
      businessTypeId: action.payload.businessTypeId,
      ...(action.payload.captureDataFromChildren !== undefined && { captureDataFromChildren: action.payload.captureDataFromChildren })
    };

    const response: {json: any} = yield call(httpPost, 
      url,
      requestPayload, 
      token
    );
    const performanceReport: IPerformanceReport = yield call([response, response.json]);
    if((performanceReport as any as {error: string})?.error) {
      yield put(displayMessage((performanceReport as any as {error: string}).error, "error"));
      yield put(clearLoadingReport());
    } else {
      yield put(createPerformanceReportSuccess(performanceReport));
    }
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchCreatePerformanceReport() {
  yield takeLatest(CREATE_PERFORMANCE_REPORT, createPerformanceReportSaga);
}

// Load Report
function* loadPerformanceReportSaga(action: LoadPerformanceReportAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/${action.payload.id}`,
      token
    );
    const performanceReport: IPerformanceReport = yield call([response, response.json]);
    yield put(loadPerformanceReportSuccess(performanceReport));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchLoadPerformanceReport() {
  yield takeLatest(LOAD_PERFORMANCE_REPORT, loadPerformanceReportSaga);
}


// Save Report 
function* savePerformanceReportSaga(action: SavePerformanceReportAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/saveItemValues/${action.payload.performanceReport.id}`,
      action.payload.performanceReport.performanceReportItemValues, 
      token
    );
    const performanceReport: IPerformanceReport = yield call([response, response.json]);

    yield put(savePerformanceReportSuccess(performanceReport));
    
    //yield put( displayMessage('Report Saved Successfully', 'success'));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchSavePerformanceReport() {
  yield takeLatest(SAVE_PERFORMANCEREPORT, savePerformanceReportSaga);
}

function* submitPerformanceReportSaga(action: SubmitPerformanceReportAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/submit/${action.payload.performanceReport.id}`,
      action.payload.performanceReport.performanceReportItemValues, 
      token
    );
    const performanceReport: IPerformanceReport = yield call([response, response.json]);
    yield put(submitPerformanceReportSuccess(performanceReport));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchSubmitPerformanceReport() {
  yield takeLatest(SUBMIT_PERFORMANCEREPORT, submitPerformanceReportSaga);
}

function* unlockPerformanceReportSaga(action: UnlockPerformanceReportAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/unlock/${action.payload.performanceReport.id}`,
      action.payload.performanceReport.performanceReportItemValues, 
      token
    );
    const performanceReport: IPerformanceReport = yield call([response, response.json]);
    yield put(unlockPerformanceReportSuccess(performanceReport));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchUnlockPerformanceReport() {
  yield takeLatest(UNLOCK_PERFORMANCEREPORT, unlockPerformanceReportSaga);
}


function* submitTabPerformanceReportSaga(action: SubmitTabPerformanceReportAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/submitTab/${action.payload.performanceReport.id}/${action.payload.categoryId}/${action.payload.statusId}`,
      action.payload.performanceReport.performanceReportItemValues, 
      token
    );
    const performanceReport: IPerformanceReport = yield call([response, response.json]);
    yield put(submitTabPerformanceReportSuccess(performanceReport, action.payload.categoryId, action.payload.statusId === DpgReportStatuses.submitted));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchSubmitTabPerformanceReport() {
  yield takeLatest(SUBMIT_PERFORMANCEREPORT_TAB, submitTabPerformanceReportSaga);
}

function* loadCompletedPerformanceReportTabSaga(action: LoadCompletedPerformanceReportTabsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/completedCategories/${action.payload.id}`,
      token
    );
    const completedCategoryInfo: {completedCategoryIds: string[]} = yield call([response, response.json]);
    yield put(loadCompletedPerformanceReportTabsSuccess(completedCategoryInfo.completedCategoryIds));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}
export function* watchloadCompletedPerformanceReportTab() {
  yield takeLatest(LOAD_COMPLETED_PERFORMANCEREPORT_TABS, loadCompletedPerformanceReportTabSaga);
}




function* printBHPHReportSaga(action: PrintBuyHerePayHereReportAction) {
  try {
    const token: string = yield authService.getToken();
    const url: string = action.payload.clientId
      ? `${authService.appSettings.GetWebApiBaseUri()}/document/buyHerePayHere/${action.payload.clientId}`
      : `${authService.appSettings.GetWebApiBaseUri()}/document/buyHerePayHere`;

    const response: {json: any} = yield call(httpPost, 
      url,
      {month: action.payload.month, year: action.payload.year, isBlank: action.payload.isBlank === true}, 
      token
    );
    const fileName = action.payload.isBlank === true ? "BHPHReport.pdf" : `${action.payload.clientId}.${action.payload.month}.${action.payload.year}.BHPHReport.pdf`;
    yield saveFile(response as any, fileName);
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchPrintPerformanceReport() {
  yield takeLatest(PRINT_BHPH_REPORT, printBHPHReportSaga);
}


function* printRetailReportSaga(action: PrintRetailReportAction) {
  try {
    const token: string = yield authService.getToken();
    const url: string = action.payload.clientId
      ? `${authService.appSettings.GetWebApiBaseUri()}/document/retail/${action.payload.clientId}`
      : `${authService.appSettings.GetWebApiBaseUri()}/document/retail`;

    const response: {json: any} = yield call(httpPost, 
      url,
      {month: action.payload.month, year: action.payload.year, isBlank: action.payload.isBlank === true}, 
      token
    );
    const fileName = action.payload.isBlank === true ? "RetailReport.pdf" : `${action.payload.clientId}.${action.payload.month}.${action.payload.year}.RetailReport.pdf`;
    yield saveFile(response as any, fileName);
  }
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchPrintRetailPerformanceReport() {
  yield takeLatest(PRINT_RETAIL_REPORT, printRetailReportSaga);
}

// Dealer Reports
function* loadDealerReportsSaga(action: LoadDealerReportsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/dealerReports/${action.payload.clientId}`,
      token
    );
    const dealerReports: DealerReport[] = yield call([response, response.json]);
    yield put(loadDealerReportsSuccess(dealerReports));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadDealerReports() {
  yield takeLatest(LOAD_DEALER_REPORTS, loadDealerReportsSaga);
}

// All Dealer Reports
function* loadAllDealerReportsSaga(action: LoadAllDealerReportsAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet, 
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/allDealerReports`,
      token
    );
    const dealerReports: DealerReport[] = yield call([response, response.json]);
    yield put(loadAllDealerReportsSuccess(dealerReports));
  } 
  catch (error: any) {
    yield put(displayError(error));
  }
}

export function* watchLoadAllDealerReports() {
  yield takeLatest(LOAD_ALL_DEALER_REPORTS, loadAllDealerReportsSaga);
}

// function* rollupPerformanceReportSaga(action: RollupPerformanceReportAction) {
//   try {
//     const token: string = yield authService.getToken();
//     const response: { json: any } = yield call(
//       httpPost,
//       `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/rollupReport/${action.payload.reportId}`,
//       null, 
//       token
//     );

//     yield put(rollupPerformanceReportSuccess());
//     yield put(displayMessage('Child performance data has been rolled up into this report.', 'success'));
//     yield put(loadPerformanceReport(action.payload.reportId));
//   } catch (error: any) {
//     yield put(rollupPerformanceReportFailure(error));
//     yield put(displayError(error));
//   }
// }

// function* rollupPerformanceReportSaga(action: RollupPerformanceReportAction) {
//   try {
//     const token: string = yield authService.getToken();
//     const response: { json: any } = yield call(
//       httpPost,
//       `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/rollupReport/${action.payload.reportId}`,
//       null,
//       token
//     );

//     // Try to read the JSON body (could be a report or an { error } object)
//     let body: any = null;
//     try {
//       body = yield call([response, response.json]);
//     } catch {
//       // If no JSON body (unlikely here), treat it as success and continue
//     }

//     const errorMsg: string | undefined = body?.error ?? body?.Error;
//     if (errorMsg) {
//       // Show backend-provided error and bail out (do not fire success/load)
//       yield put(displayMessage(errorMsg, 'error'));
//       return;
//     }

//     // Success path: preserve current behavior
//     yield put(rollupPerformanceReportSuccess());
//     yield put(displayMessage('Child performance data has been rolled up into this report.', 'success'));
//     yield put(loadPerformanceReport(action.payload.reportId));
//   } catch (error: any) {
//     yield put(displayError(error));
//   }
// }


function* rollupPerformanceReportSaga(
  action: RollupPerformanceReportAction
): Generator<any, void, any> {
  try {
    const token: string = yield authService.getToken();
    const response: Response = yield call(
      httpPost,
      `${authService.appSettings.GetWebApiBaseUri()}/PerformanceReport/rollupReport/${action.payload.reportId}`,
      null,
      token
    );

    let body: { error?: string; Error?: string } | null = null;
    try {
      body = (yield call([response, response.json])) as {
        error?: string;
        Error?: string;
      };
    } catch {
      // If no JSON body, ignore and continue
    }

    const errorMsg = body?.error ?? body?.Error;
    if (errorMsg) {
      yield put(displayMessage(errorMsg, 'error'));
      yield put(loadPerformanceReport(action.payload.reportId));
      return;
    }

    yield put(rollupPerformanceReportSuccess());
    yield put(displayMessage('Child performance data has been rolled up into this report.', 'success'));
    yield put(loadPerformanceReport(action.payload.reportId));
  } catch (error: any) {
    yield put(displayError(error));
  }
}



// --- watcher ---
export function* watchRollupPerformanceReport() {
  yield takeLatest(ROLLUP_PERFORMANCEREPORT, rollupPerformanceReportSaga);
}


export default function* performanceReportSagas() {
  yield all([
    watchCreatePerformanceReport(),
    watchLoadPerformanceReport(),
    watchSavePerformanceReport(),
    watchSubmitPerformanceReport(),
    watchSubmitTabPerformanceReport(),
    watchloadCompletedPerformanceReportTab(),
    watchPrintPerformanceReport(),
    watchPrintRetailPerformanceReport(),
    watchUnlockPerformanceReport(),
    watchLoadDealerReports(),
    watchLoadAllDealerReports(),
    watchRollupPerformanceReport()
  ])
}

export const saveFile = async (response: Response, fallbackFileName: string) => {
  const blob = await response.blob();
  var contentDisposition = response.headers.get('content-disposition');
  var fileName = contentDisposition?.split(';')?.[1].split('filename')?.[1]?.split('=')?.[1]?.trim()
      ?? fallbackFileName;
  // Remove leading/trailing quotes.
  if (fileName.startsWith('"')) {
      fileName = fileName.substring(1);
  }
  if (fileName.endsWith('"')) {
      fileName = fileName.substring(0, fileName.length - 1);
  }
  
  if ((window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
  } else {
      const anchor = window.document.createElement('a');
      anchor.href = window.URL.createObjectURL(blob);
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(anchor.href);
  }
}